<template>
  <div>
    <div
      v-if="value"
      class="table_label d-flex"
      :class="[primary ? 'primary' : '', info ? 'info' : '']"
    >
      <span>{{ text }}</span>
      <span>{{ value }}</span>
      <el-link
        type="warning"
        v-if="showGaps"
        class="ml-2"
        style="font-size: 13px;"
        @click.stop="openShowGapTable"
        >{{ $l('btn_show_combine_sku') || '查看组合产品' }}</el-link
      >
    </div>
    <el-dialog
      :title="$l('dialog_title_combine_info') || '组合产品信息'"
      :visible.sync="gapVisible"
      :show-close="true"
      width="800px"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div class="mb-4">
        <div class="d-flex mt-2" v-if="showCompletesTable">
          <div class="side-frame"></div>
          <div style="font-size: 14px; color: #606266; font-weight: 600;">
            {{ $l('title_combine_qty') || '成套数量' }}：{{ value }}
          </div>
        </div>
        <vxe-grid
          v-if="showCompletesTable"
          auto-resize
          highlight-hover-row
          :data="completesTable"
          :columns="completesColumns"
          size="small"
          resizable
          border
          :seq-config="{
            startIndex: 0,
          }"
        >
          <template v-slot:displayQty="{ row }">
            <span>{{ row.quantityGaps }}</span>
          </template>
          <template v-slot:empty="{}">
            <div style="text-align: center">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">
                {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
              </p>
            </div>
          </template>
        </vxe-grid>
        <div class="d-flex mt-4" v-if="showGapsTable">
          <div class="side-frame"></div>
          <div style="font-size: 14px; color: #606266; font-weight: 600;">
            {{ $l('title_sub_sku_gap') || '子件缺口' }}
          </div>
        </div>
        <vxe-grid
          v-if="showGapsTable"
          auto-resize
          highlight-hover-row
          :data="gapsTable"
          :columns="gapsColumns"
          size="small"
          resizable
          border
          :seq-config="{
            startIndex: 0,
          }"
        >
          <template v-slot:displayQty="{ row }">
            <span
              :class="{
                'color-red': row.quantityGaps < 0,
              }"
              >{{ row.quantityGaps }}</span
            >
          </template>
          <template v-slot:empty="{}">
            <div style="text-align: center">
              <img src="/image/static/img/nodata.png" />
              <p class="no-data">
                {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
              </p>
            </div>
          </template>
        </vxe-grid>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: '' },
    value: { type: String, default: '' },
    info: { type: Boolean, default: false },
    primary: { type: Boolean, default: false },
    labelKey: { type: String, default: '' },
    funcID: { type: String, default: '' },
    global: { type: Boolean, default: false },
    gaps: { type: String, default: '' },
  },
  data() {
    return {
      gapVisible: false,
      completesColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: this.$l('completes_table_evg_sku_no') || '产品编号',
          field: 'evgSkuNo',
          minWidth: 160,
          align: 'center',
        },
        {
          title: this.$l('completes_table_goods_name') || '产品名称',
          field: 'goodsName',
          minWidth: 160,
          align: 'center',
        },
        {
          title: this.$l('completes_table_quantity_gaps') || '数量',
          field: 'quantityGaps',
          minWidth: 170,
          align: 'center',
          slots: { default: 'displayQty' },
        },
      ],
      gapsColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: this.$l('gaps_table_evg_sku_no') || '产品编号',
          field: 'evgSkuNo',
          minWidth: 160,
          align: 'center',
        },
        {
          title: this.$l('gaps_table_goods_name') || '产品名称',
          field: 'goodsName',
          minWidth: 160,
          align: 'center',
        },
        {
          title: this.$l('gaps_table_quantity_gaps') || '数量',
          field: 'quantityGaps',
          minWidth: 170,
          align: 'center',
          slots: { default: 'displayQty' },
        },
      ],
    }
  },
  computed: {
    text() {
      if (!this.labelKey) return this.label || ''
      const funcID = this.global ? 'INDEX' : ''
      const labelKey = [funcID, this.labelKey].filter(Boolean).join('.')
      return this.$l(labelKey) || ''
    },
    showGaps() {
      return this.gaps
    },
    gapsTable() {
      return JSON.parse(this.gaps || '{}')['gapSubs'] || []
    },
    showGapsTable() {
      return this.gapsTable.length > 0
    },
    completesTable() {
      return JSON.parse(this.gaps || '{}')['completes'] || []
    },
    showCompletesTable() {
      return this.completesTable.length > 0
    },
  },
  methods: {
    openShowGapTable() {
      this.gapVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.table_label {
  span:empty {
    display: none;
  }
  span:first-child {
    &::after {
      content: '：';
    }
  }
}
.table_label.info {
  span:last-child {
    color: #303133;
  }
}
.table_label.primary {
  span:last-child {
    color: #409eff;
  }
}
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
.color-red {
  color: #e70f0f;
}
</style>
